export default __webpack_public_path__ + "static/media/lockpadMenu.fec9a53c.jpg";